import React from 'react';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import ReportProgressModal, {
    type ReportProgressItem,
    type ReportProgressPhase,
    type ReportProgressSummary,
} from './ReportProgressModal';

export type BulkTestBillingItemStatus = ReportProgressItem['status'];
export type BulkTestBillingPhase = ReportProgressPhase;
export type BulkTestBillingSummary = ReportProgressSummary;

export type BulkTestBillingItem = {
    orderId: string;
    label: string;
    status: BulkTestBillingItemStatus;
    message?: string;
    copyDocId?: string;
};

type BulkTestBillingModalProps = {
    open: boolean;
    phase: BulkTestBillingPhase;
    items: BulkTestBillingItem[];
    summary: BulkTestBillingSummary | null;
    onConfirm: () => void;
    onClose: () => void;
};

const BulkTestBillingModal: React.FC<BulkTestBillingModalProps> = ({
    open,
    phase,
    items,
    summary,
    onConfirm,
    onClose,
}) => (
    <ReportProgressModal
        open={open}
        phase={phase}
        title="Set all to Test-Billing"
        subtitle="Bulk convert pending GST food orders into test-billing copies"
        headerIcon={<SwapHorizRoundedIcon />}
        stepLabels={['Review', 'Migrate', 'Done']}
        alertContent={
            <p>
                Creates a test-billing copy (<code>isGstBill: false</code>) for{' '}
                <strong>{items.length}</strong> pending food order(s), then resets the original order fields
                (cart, discount, payment, etc.). Room bills are not affected.
            </p>
        }
        listSectionLabel="Orders to migrate"
        items={items.map((item) => ({
            id: item.orderId,
            label: item.label,
            status: item.status,
            message: item.message,
            detail: item.copyDocId,
        }))}
        summary={summary}
        confirmLabel="Start migration"
        completeProgressLabel="Migration complete"
        startProgressLabel="Starting migration…"
        runningProgressLabel="Processing"
        runningButtonLabel="Migration in progress…"
        successStatLabel="Converted"
        detailPrefix="Copy"
        onConfirm={onConfirm}
        onClose={onClose}
    />
);

export default BulkTestBillingModal;
